import admin from './admin';
import analytics from './analytics';
import content from './content';
import processing from './processing';
import screen from './screen';
import support from './support';
import test from './test';
import type { MenuGroup } from './types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: {
    items: MenuGroup[];
} = {
    items: [test, screen, content, processing, analytics, admin, support],
};

export default menuItems;
